"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
exports.getRemoteConfigUrl = getRemoteConfigUrl;
exports.isRemoteConfigEnable = isRemoteConfigEnable;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _base = require("./base");
// 需要检查是否需要字符串格式化为正则的配置路径
var REG_FORMAT_PATHS = ['filters.exception', 'filters.resource', 'tracing.allowedUrls.[].match'];
function isRemoteConfigEnable(config) {
  return config.remoteConfig === true || config.remoteConfig && config.remoteConfig.enable !== false;
}

/**
 * 
 * @param config 
 * @returns 
 */
function getRemoteConfigUrl(config) {
  if (config.remoteConfig && config.remoteConfig.url) {
    return config.remoteConfig.url;
  }
  var sereis = config.pid.split('@');
  if (!sereis || sereis.length < 2) return;
  var timestamp = Date.now();
  return "//" + sereis[0] + "-sdk.rum.aliyuncs.com/config/" + (config.remoteConfig.region || 'cn-hangzhou') + "/" + sereis[1] + "?t=" + timestamp;
}

/**
 * 
 * @param oldConfig 
 * @param remoteConfig 
 */
function doCover(oldConfig, remoteConfig) {
  if (oldConfig === void 0) {
    oldConfig = {};
  }
  if (remoteConfig === void 0) {
    remoteConfig = {};
  }
  for (var key in oldConfig) {
    var _remoteConfig, _remoteConfig2;
    if (key === 'pid' || key === 'endpoint') continue;
    if (((_remoteConfig = remoteConfig) === null || _remoteConfig === void 0 ? void 0 : _remoteConfig[key]) === undefined) continue;
    var oldV = oldConfig[key];
    var newV = (_remoteConfig2 = remoteConfig) === null || _remoteConfig2 === void 0 ? void 0 : _remoteConfig2[key];
    if ((0, _base.getType)(oldV) === 'object' && (0, _base.getType)(newV) === 'object') {
      doCover(oldV, newV);
    } else {
      oldConfig[key] = newV;
    }
  }
}

/**
 * 
 * @param oldConfig 
 * @param remoteConfig 
 */
function doSupplement(oldConfig, remoteConfig) {
  if (oldConfig === void 0) {
    oldConfig = {};
  }
  if (remoteConfig === void 0) {
    remoteConfig = {};
  }
  for (var key in remoteConfig) {
    var _oldConfig;
    if (((_oldConfig = oldConfig) === null || _oldConfig === void 0 ? void 0 : _oldConfig[key]) === undefined) {
      oldConfig[key] = remoteConfig[key];
    } else {
      var oldV = oldConfig[key];
      var newV = remoteConfig[key];
      if ((0, _base.getType)(oldV) === 'object' && (0, _base.getType)(newV) === 'object') {
        doSupplement(oldV, newV);
      }
    }
  }
}

/**
 * 
 * @param oldConfig 
 * @param remoteConfig 
 * @returns config
 */
function combineConfig(oldConfig, remoteConfig) {
  if (oldConfig === void 0) {
    oldConfig = {};
  }
  if (remoteConfig === void 0) {
    remoteConfig = null;
  }
  if (!remoteConfig) return null;
  if ((0, _base.getType)(oldConfig) !== 'object' || (0, _base.getType)(remoteConfig) !== 'object') return null;
  var config = (0, _extends2["default"])({}, oldConfig);
  // 先检查远程配置的，是否有需要将字符串格式化为正则的
  (0, _base.toRegFormat)(remoteConfig, REG_FORMAT_PATHS);
  // 执行覆盖
  doCover(config, remoteConfig);
  // 执行补充
  doSupplement(config, remoteConfig);
  return config;
}
var _default = exports["default"] = combineConfig;